/**
 * TableMenu — bulk-action menu that sits in the header of the
 * trailing "actions" column (the one MRT synthesises when
 * `renderRowActions` or `renderRowActionMenuItems` is enabled).
 *
 * Behaves exactly like the legacy version: popover anchored to the
 * header cell, loading/success/failure states driven by the thunk's
 * REQUEST_STATUS, custom options supplied by the page via
 * `tableMenuPopoverOptions(setAnchorEl)`. The popover surface is
 * still a legacy MenuItemWithPopover — its visual refresh is a
 * separate task (the Menu/Popover stack pulls in the dialog chrome
 * used elsewhere in the shell).
 */
import { useState } from 'react';
import { useSelector } from 'react-redux';
import MenuItemWithPopover from '@shared/ui/Table/menu-items/MenuItemWithPopover';
import { REQUEST_STATUS } from 'redux_store';
import { ReactComponent as MenuIcon } from 'assets/icons/expand_circle_down.svg';

const TableMenu = ({ tableMenuPopoverOptions, tableMenuStatus, isLoading }) => {
  const { tables: tTables } = useSelector(state => state.i18n);
  const [anchorElMulti, setAnchorElMulti] = useState();

  if (isLoading) {
    return (
      <div
        style={{
          maxHeight: 20,
          borderRadius: 4,
          position: 'absolute',
          display: 'flex',
          background: 'var(--qhs-surface-hover)',
          width: 30,
          height: 20,
          left: '50%',
          top: 0,
          transform: 'translate(-50%, 0)',
        }}
      />
    );
  }

  return (
    <div id="more-table-button" style={{ width: 19, height: '100%', minHeight: 24 }}>
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minWidth: '100%',
          color: 'var(--qhs-text-3)',
        }}
      >
        <MenuItemWithPopover
          icon={<MenuIcon />}
          label={tTables.multiLineActions}
          anchorEl={anchorElMulti}
          setAnchorEl={setAnchorElMulti}
          isLoading={tableMenuStatus === REQUEST_STATUS.loading}
          isSuccess={tableMenuStatus === REQUEST_STATUS.succeeded}
          isFailed={tableMenuStatus === REQUEST_STATUS.failed}
          popoverOptions={tableMenuPopoverOptions(setAnchorElMulti)}
        />
      </div>
    </div>
  );
};

export default TableMenu;
